import {sizes} from '../styles/components/media-queries';
import {createGlobalStyle} from 'styled-components';

export const GlobalStyled = createGlobalStyle`

    @font-face {
        font-family: 'Open Sans';
        src: url('https://fonts.googleapis.com/css?family=Open+Sans') format('embedded-opentype');
    }

    @font-face {
        font-family: 'icomoon';
        src: url('/api/fastly-assets/fonts/icomoon.eot');
        src: url('/api/fastly-assets/fonts/icomoon.eot#iefix') format('embedded-opentype'),
        url('/api/fastly-assets/fonts/icomoon.ttf') format('truetype'),
        url('/api/fastly-assets/fonts/icomoon.woff') format('woff'),
        url('/api/fastly-assets/fonts/icomoon.svg#icomoon') format('svg');

        font-weight: normal;
        font-style: normal;
    }

    html {
        box-sizing: border-box;
        font-size: 62.5%;
        background-color: white;
    }

    html,
    body {
        margin: 0;
        padding: 0;
        font-family: 'Open Sans', sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
    }

    *,
    *:before,
    *:after {
        box-sizing: inherit;
        box-sizing: border-box;
    }

    a {
        text-decoration: none;
    }

    .ReactModal__Content {
        max-height: 100%;
    }

    .zsiq_theme1 .zsiq_flt_rel {
        width: 50px !important;
        border-radius: 50px !important;
        height: 50px !important;
    }

    .zsiq_theme1 .siqico-chat:before {
        font-size: 25px !important;
        line-height: 50px !important;
    }

    header.noaboutme.nologo {
        height: 80px !important;
        max-height: 80px;
    }

    @media (max-width: ${sizes.small}px) {
        .ReactModal__Content {
            width: 100%;
            height: 100%;
            background: transparent !important;
        }
    }

    // CSS classes for MarkDown content
    .columns-2 {
        columns: 2;
        column-gap: 5rem;
    }

    .forceBreak {
        -webkit-column-break-after: always;
        break-after: column;
    }

    span.forceBreak {
        display: block;
    }

    div[class^="BlogPagestyle__Wrapper"] {
        font-size: 1.6rem;
    }

    div[class^="BlogPagestyle__PostNode"] h1,
    div[class^="BlogPagestyle__PostNode"] h2,
    div[class^="BlogPagestyle__PostNode"] h3,
    div[class^="BlogPagestyle__PostNode"] h4,
    div[class^="BlogPagestyle__PostNode"] h5,
    div[class^="BlogPagestyle__PostNode"] h6,
    div[class^="BlogPagestyle__PostNode"] h1 span,
    div[class^="BlogPagestyle__PostNode"] h2 span,
    div[class^="BlogPagestyle__PostNode"] h3 span,
    div[class^="BlogPagestyle__PostNode"] h4 span,
    div[class^="BlogPagestyle__PostNode"] h5 span,
    div[class^="BlogPagestyle__PostNode"] h6 span,
    div[class^="BlogPagestyle__Wrapper"] h1,
    div[class^="BlogPagestyle__Wrapper"] h2,
    div[class^="BlogPagestyle__Wrapper"] h3,
    div[class^="BlogPagestyle__Wrapper"] h4,
    div[class^="BlogPagestyle__Wrapper"] h5,
    div[class^="BlogPagestyle__Wrapper"] h6,
    div[class^="BlogPagestyle__Wrapper"] h1 span,
    div[class^="BlogPagestyle__Wrapper"] h2 span,
    div[class^="BlogPagestyle__Wrapper"] h3 span,
    div[class^="BlogPagestyle__Wrapper"] h4 span,
    div[class^="BlogPagestyle__Wrapper"] h5 span,
    div[class^="BlogPagestyle__Wrapper"] h6 span,
    div[class^="BlogPagestyle__PostNode"] [class^="BlogNodestyle__BlogHeading"],
    div[class^="BlogPagestyle__Wrapper"] [class^="BlogNodestyle__BlogHeading"] {
        color: #26ae5d;
        font-size: 2.6rem;
        font-weight: 200;
        line-height: 2.7rem;
    }

    div[class^="BlogPagestyle__Wrapper"] p, div[class^="BlogPagestyle__Wrapper"] span {
        color: rgb(117, 117, 117);
    }

    a > span[class^="SearchPagestyle__BreadCrumbResult"],
    div[class^="BlogPagestyle__PostNode"] a,
    div[class^="BlogPagestyle__Wrapper"] a {
        color: #3594cc;
    }

    div[class^="BlogPagestyle__Wrapper"] [class^="BlogNodestyle__ParagraphWrapper"] img,
    div[class^="BlogPagestyle__PostNode"] [class^="BlogNodestyle__ParagraphWrapper"] img,
    div[class^="BlogPagestyle__PostNode"] p img,
    div[class^="BlogPagestyle__Wrapper"] img {
        max-width: 100%;
        height: auto !important;
    }

    div[class^="BlogPagestyle__Wrapper"] [class^="BlogNodestyle__BlogButtonWrapper"] {
        text-align: center;
        display: block;
        margin: 15px 0;
    }

    [class^="BlogPagestyle__PostNode"] [class^="BlogNodestyle__BlogButtonWrapper"] a[class^="BlogNodestyle__BlogButtonNode"] {
        color: #fff;
    }

    div[class^="BlogPagestyle__Wrapper"] [class^="BlogNodestyle__ParagraphWrapper"] {
        font-size: 1.6rem;
        min-width: 100%;
        margin: 2rem 0;
        line-height: 2.7rem;
    }

    div[class^="BlogPagestyle__Wrapper"] [class^="BlogNodestyle__LineBreak"] {
        height: 0.5rem;
        min-height: 0.5rem;
    }

    [class^="BlogNodestyle__BlogButtonWrapper"] {
        width: 100%;
        margin: 1.5rem 0;
        display: flex;
        justify-content: center;
    }

    [class^="BlogNodestyle__BlogButtonNode"] .jjLinkButton,
    a[class^="BlogNodestyle__BlogButtonNode"],
    [class^="BlogPagestyle__PostNode"] .jjLinkButton,
    div[class^="BlogPagestyle__Wrapper"] .jjLinkButton {
        max-width: max-content;
        font-size: 16px;
        padding: 12px 14px;
        color: #fff;
        background-color: #607a80;
        text-decoration: none;
        border-radius: 30px;
        max-height: 42px;
        margin: 0 auto;
    }

    a.olive-green {
        background-color: #a9a251 !important;
    }

    a.sage-gray {
        background-color: #848e7e !important;
    }

    a.copper-orange {
        background-color: #d0874a !important;
    }

    a.burnt-sienna {
        background-color: #dd623a !important;
    }

    a.charcoal {
        background-color: #3f3f3d !important;
    }

    a.slate-gray {
        background-color: #686866 !important;
    }

    div[class^="BlogPagestyle__Wrapper"] iframe {
        max-width: 100%;
        height: auto;
        aspect-ratio: 2.32;
    }


    div[class^="BlogPagestyle__Wrapper"] ul.jj-content-ul {
        display: flex;
        padding: 0;
        width: 100%;
        list-style-type: none;
    }

    div[class^="BlogPagestyle__Wrapper"] ul.jj-content-ul h2 {
        color: #26ae5d;
        text-transform: capitalize;
        font-size: 22px;
        font-weight: lighter
    }

    div[class^="BlogPagestyle__Wrapper"] ul li {
        margin-bottom: 0.8rem;
    }

    div[class^="BlogPagestyle__Wrapper"] ul.jj-content-ul li {
        text-align: center;
        flex-basis: 33%;
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    div[class^="BlogPagestyle__PostNode"] p {
        max-width: none;
    }

    div[class^="BlogPagestyle__PostNode"] p,
    div[class^="BlogPagestyle__Wrapper"] ul.jj-content-ul p {
        color: #797979;
        font-size: 16px;
        line-height: 24px;

    }

    div[class^="BlogPagestyle__Wrapper"] ul.jj-content-ul p {
        max-width: 240px;
    }

    div[class^="BlogPagestyle__Wrapper"] ul.jj-content-ul img {
        width: 240px;
    }

    article[class^="ShopBySectorsstyle__Wrapper"] > div > div[class^="BlogPagestyle__MainTitle"],
    div[class^="BlogPagestyle__PostNode"] > div > div[class^="BlogPagestyle__MainTitle"],
    div[class^="BlogPagestyle__PostNode"] > div > div > div[class^="BlogPagestyle__MainTitle"],
    div[class^="BlogPagestyle__Wrapper"] [class^="BlogPagestyle__PostBar-"] {
        display: none;
    }

    div[class^="BlogNodestyle__LineBreak"] {
        height: 0.5rem;
        min-height: 0.5rem;
    }

    div[class^="BlogNodestyle__BlogGalleryContainer"] {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
    }

    div[class^="BlogNodestyle__BlogGalleryWrapper"] {
        display: inline-flex;
        flex-wrap: wrap;
        margin: 0;
        min-width: 100%;
        gap: 10px;
    }

    img[class^="BlogNodestyle__BlogImageBlock"] {
        max-width: 100%;
    }

    img[class^="BlogNodestyle__BlogImageBlock"]:not([width]):not([style*="width"]) {
        width: 100%;
    }

    img.contentImage,
    img[class^="BlogNodestyle__BlogImageBlock"][width],
    img[class^="BlogNodestyle__BlogImageBlock"][style*="width"] {
        max-width: 100%;
        width: auto;
        height: auto;
    }

    [class^=BlogNodestyle__BlogGalleryWrapper] img[class^="BlogNodestyle__BlogImageBlock"] {
        height: revert-layer;
    }

    span[class^="BlogNodestyle__BlogText"] {
        font-size: 1.6rem;
        line-height: 2.4rem;
        margin: 1rem 0;
        color: #797979;
    }

    table[class^="BlogNodestyle__BlogTableNode"] {
        width: 100%;
        position: relative;
        table-layout: fixed;
        border-spacing: 0;
    }

    tr[class^="BlogNodestyle__BlogTR"] {
        width: 100%;
        position: relative;
    }

    td[class^="BlogNodestyle__BlogTD"] {
        vertical-align: TOP;
        border-top-width: 0;
        border-left-width: 0;
        border-right-width: 0;
        border-bottom-width: 0;
        min-width: 120px;
        padding: 1rem 2rem;
        border-left-color: #FFFFFF;
        border-right-color: #FFFFFF;
        border-top-color: #FFFFFF;
        border-bottom-color: #FFFFFF;
        background-color: transparent;
        border-style: solid;
    }

    a[class^="BlogNodestyle__BlogLink"] {
        display: inline;
        padding: 0 0.2rem;
        margin: 1rem 0;
        font-size: 1.6rem;
        line-height: 2.4rem;
        cursor: pointer;
        color: #3594cc;
    }

    span[class^="BlogNodestyle__BlogHeading"] {
        font-size: 2.6rem;
        line-height: 5rem;
        font-weight: lighter;
        color: #26ae5d;
    }

    iframe[class^="BlogNodestyle__BlogVideoIframe"] {
        max-width: 100%;
        height: auto;
        max-height: 50rem;
        border: 0;
        aspect-ratio: 16/9;
    }


    ul.jj-content-ul {
        display: flex;
        padding: 0;
        width: 100%;
        list-style-type: none;
    }

    ul.jj-content-ul h2 {
        color: #26ae5d;
        text-transform: capitalize;
        font-size: 22px;
        font-weight: lighter
    }

    ul.jj-content-ul li {
        text-align: center;
        flex-basis: 33%;
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    ul.jj-content-ul p {
        color: #797979;
        font-size: 16px;
        line-height: 24px;
        max-width: 240px;
    }

    ul.jj-content-ul img {
        width: 240px;
    }

    article[class^="ShopBySectorsstyle__Wrapper"] img[class^="BlogNodestyle__BlogImageBlock"] {
        height: auto;
    }

    article[class^="ShopBySectorsstyle__Wrapper"] table colgroup {
        display: none;
    }

    article[class^="ShopBySectorsstyle__Wrapper"] table tr {
        display: flex;
        flex-wrap: wrap;
    }

    article[class^="ShopBySectorsstyle__Wrapper"] table tr td[class^="BlogNodestyle__BlogTD"] * {
        text-align: left !important;
    }

    article[class^="ShopBySectorsstyle__Wrapper"] table tr td[class^="BlogNodestyle__BlogTD"] a {
        font-size: 1.4rem;
    }

    article[class^="ShopBySectorsstyle__Wrapper"] table tr td[class^="BlogNodestyle__BlogTD"] {
        text-align: left;
        flex: 1;
        min-width: 25%;

    }

    @media (max-width: 768px) {
        article[class^="ShopBySectorsstyle__Wrapper"] table tr td[class^="BlogNodestyle__BlogTD"] {
            min-width: 50%;
            display: block;
        }
    }

    @media (max-width: 480px) {
        article[class^="ShopBySectorsstylea_Wrapper"] table tr td[class^="BlogNodestyle__BlogTD"] {
            min-width: 100%;
            display: block;
        }
    }

    span[class^="BlogNodestyle__BlogText"], [class^=BlogNodestyle__ParagraphWrapper] table td p, [class^=BlogNodestyle__ParagraphWrapper] p {
        font-size: 1.6rem;
        line-height: 2.4rem;
        margin: 1rem 0;
        color: #797979
    }

    .CookieConsent {
        flex-wrap: nowrap !important;
        flex-direction: row-reverse;
        align-items: center !important;
        padding-left: 1rem;
    }

    .CookieConsent > div:first-child {
        margin: 1rem !important;
    }

    #rcc-confirm-button {
        margin: 1rem !important;
    }
    @media (max-width: 480px) {
        .livesdk__welcome-screen {
            background-size: 105% !important;
        }
        .CookieConsent {
            flex-wrap: wrap;
            flex-direction: column;
            padding-left: 0;
        }
        .CookieConsent > div:first-child {
            margin:  1rem 1rem 0 1rem !important;
        }
        .CookieConsent > div:last-child {
            width: 100%;
        }

    }
`;
